import { createSelector } from 'reselect';

import { getUser } from './user.selectors';

const selectUserPropertiesState = createSelector(getUser, ({ userProperties }) => userProperties);

export const selectPropertyDefinitions = createSelector(
  selectUserPropertiesState,
  userProperties => userProperties?.propertyDefinitions || [],
);

export const selectUserOverrides = createSelector(
  selectUserPropertiesState,
  userProperties => userProperties?.userOverrides || [],
);
